import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var AvatarCss = function AvatarCss(props) {
  var _getThemeData = getThemeData(props, 'avatar'),
    lgSize = _getThemeData.lgSize,
    lgFontSize = _getThemeData.lgFontSize,
    Size = _getThemeData.Size,
    fontSize = _getThemeData.fontSize,
    smSize = _getThemeData.smSize,
    smFontSize = _getThemeData.smFontSize,
    c7nSquareBorderRadius = _getThemeData.c7nSquareBorderRadius,
    largeAvatarStringTop = _getThemeData.largeAvatarStringTop,
    smallAvatarStringTop = _getThemeData.smallAvatarStringTop;
  return css([".c7n-avatar.c7n-avatar{font-size:", "px;width:", "px;height:", "px;&.c7n-avatar-icon{.icon::before{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);}}&.c7n-avatar-square{border-radius:", ";}.icon{font-size:", "px;}&.c7n-avatar-lg{width:", "px;height:", "px;font-size:", "px;.icon{font-size:", "px;}.c7n-avatar-string{top:", ";}}&.c7n-avatar-sm{width:", "px;height:", "px;font-size:", "px;.icon{font-size:", "px;}}}"], fontSize, Size, Size, c7nSquareBorderRadius, fontSize, lgSize, lgSize, lgFontSize, lgFontSize, largeAvatarStringTop, smSize, smSize, smFontSize, smFontSize);
};
export default AvatarCss;